import type { FaireProductEntity } from "../../entity_types/product";

export const p_7dmudjnprg: FaireProductEntity = {
  token: "p_7dmudjnprg",
  type: "product",
  name: "18K Gold Plated Stainless Steel Geometric Post Earrings -FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/f8f024840000737b87c2548ca144ecf474e1899abc363624c72b791f47c3d6dc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/263ab4b75ca796e36b989de81a8d7096b311277601c5d7cb9d9238e2485bfd1f.jpeg",
    "https://cdn.faire.com/fastly/c729902b5c35916ae9d575e41859fec52b377f108c76b1ed64268172ea812a15.jpeg",
    "https://cdn.faire.com/fastly/52087f3b3482fea629762cf471bcae4d7cf22d89c996f05ea1ba110b5d265634.jpeg",
    "https://cdn.faire.com/fastly/fe99e49e8828582c644bd8fe78d2d3faaf18ea5e7dfc904da76da0c660372c3d.jpeg",
  ],
  priceDollars: 10,
  description:
    "Type: earrings\nMaterial : 316L Stainless steel ，18K gold plated\nSize ： 18mm * 30mm\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n★Made of high quality stainless steel，Lead-free，Harmless to Human Body.\n★Perfect jewelry gifts \n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:58:55.780Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
